import React, { useEffect, useState } from 'react';

import moment from 'moment';
import { useParams } from 'react-router-dom';

import { CloseRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { OrderTypes } from '../constants/orderTypeConstants';
import { startLogoutAsync } from '../redux-store/auth/authSlice';
import { useAppDispatch } from '../redux-store/hooks';
import {
  closeSnackbar,
  enqueueSnackbar,
} from '../redux-store/notifications/notificationsSlice';
import {
  reloadOrderAsync,
  viewOrderAsync,
} from '../redux-store/orders/ordersSlice';

const useOrderReloader = (order: any) => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const [startTimeMS, setStartTimeMS] = React.useState<number>(0);
  const timerStep = 5000;
  const [pauseReloader, setPauseReloader] = useState<boolean>(false);
  const [reloadingOrder, setReloadingOrder] = React.useState<boolean>(false);
  const { id } = params;

  useEffect(() => {
    setStartTimeMS(new Date().getTime());
    dispatch(viewOrderAsync({ orderId: id as string }));
  }, [dispatch]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const timeleft = timerStep - (new Date().getTime() - startTimeMS);
      const percent = (timeleft / timerStep) * 100;
      if (percent <= 0 && !reloadingOrder) {
        setReloadingOrder(true);
        setStartTimeMS(new Date().getTime());
        setReloadingOrder(false);
        if (!pauseReloader) {
          dispatch(reloadOrderAsync({ orderId: id as string })).then(
            (response: any) => {
              if (response?.payload === 'Permission denied') {
                dispatch(startLogoutAsync(true));
              }
              const payload = response.payload;
              if (payload?.reload) {
                for (let i = 0; i < payload.messages.length; i++) {
                  const message = payload.messages[i];
                  dispatch(
                    enqueueSnackbar({
                      message: message.text,
                      key: new Date().getTime() + Math.random(),
                      options: {
                        variant: message.type,
                        persist: true,
                        action: (key: any) => (
                          <IconButton
                            onClick={() => dispatch(closeSnackbar(key))}
                            color='primary'
                            size='large'>
                            <CloseRounded style={{ color: 'white' }} />
                          </IconButton>
                        ),
                      },
                    })
                  );
                }
              }
              setReloadingOrder(false);
              setStartTimeMS(new Date().getTime());
            }
          );
        }
      }
    }, 5000);
    return () => {
      clearInterval(intervalId); //This is important
    };
  }, [dispatch, order]);

  useEffect(() => {
    if (order) {
      // We keep polling for Hybrid eClose 7 days after signing date so any uploaded InkSign can be processed on the FE
      if (
        order.OrderType.Type === OrderTypes.HybridEClose &&
        moment() > moment(order?.ExpireDate)
      ) {
        setPauseReloader(true);
      } else if (
        order.OrderType.Type !== OrderTypes.HybridEClose &&
        order.Status.toLowerCase().includes('all signed')
      ) {
        setPauseReloader(true);
      }
    }
  }, [order]);
};

export default useOrderReloader;
